import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  itemButton: {
    display: 'block',
    width: '100%'
  },
  itemInfo: {
    display: 'flex',
    padding: theme.spacing(0.5, 0, 0.5, 1),
    borderRadius: theme.spacing(0.75, 0, 0, 0.75),
    alignItems: 'center',
    margin: theme.spacing(-0.25, 0, -0.25, -1)
  },
  itemRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minWidth: 0
  },
  itemTextContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  itemUserRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: 0
  },
  itemUserGroup: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    gap: theme.spacing(0.5)
  },
  itemDropdownIcon: {
    color: theme.palette.text.secondary
  },
  itemErrorIcon: {
    fontSize: theme.spacing(2.5)
  },
  proposeButtonIcon: {
    fill: theme.palette.primary.main,
    marginLeft: theme.spacing(1)
  },
  acceptButtonIcon: {
    fill: theme.palette.success.main,
    marginLeft: theme.spacing(1)
  },
  itemButtonShadow: {
    display: 'flex',
    borderRadius: theme.spacing(5),
    '&:hover': { boxShadow: '0px 0px 0px 10px rgba(38,210,147,0.04)' },
    height: 'fit-content'
  },
  itemDelaStarIconSmall: {
    margin: theme.spacing(-0.25),
    fontSize: theme.spacing(2.5)
  }
}));

export default useStyles;
